import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { AcceptAbsenceButtonProps } from '../../types'

export const getShowBalanceButton = ({
  t,
  openBalanceDrawer,
  balanceDisabled = false,
}: AcceptAbsenceButtonProps): Action => ({
  onClick: openBalanceDrawer,
  label: t('absenceRequest.buttons.checkEmployeeSaldo'),
  testId: 'absence-request_action-check-employee-saldo',
  variant: 'text',
  color: 'inherit',
  disabled: balanceDisabled,
})
